import { render } from "./DialogAlert.vue?vue&type=template&id=8e4d4dac&scoped=true"
import script from "./DialogAlert.vue?vue&type=script&lang=js"
export * from "./DialogAlert.vue?vue&type=script&lang=js"

import "./DialogAlert.vue?vue&type=style&index=0&id=8e4d4dac&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4d4dac"]])

export default __exports__